<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content" lang="es">
        <section class="intro">
          <p>
            Cuando alguien busca <strong>Google Maps 360</strong>, suele
            referirse a las <strong>fotos 360°</strong> de un negocio en Maps —
            impulsadas por <strong>Google Street View</strong> en la Búsqueda,
            Maps y la <strong>app Street View</strong>.
          </p>
          <p>
            Aquí verás dónde aparece ese contenido, cómo usar la app Street View
            y cuándo conviene Travvir para
            <a href="/blog/es/publicar-google-street-view"
              >publicar un tour completo en Street View</a
            >.
            <strong>Por ahora,</strong> Travvir publica con su cuenta editor en
            Street View, no con la tuya.
          </p>
        </section>

        <section>
          <h2>Dónde se ve el contenido Maps 360</h2>
          <ul>
            <li>Panel de Google Business en la Búsqueda.</li>
            <li>Galería de fotos y mapa en Google Maps.</li>
            <li>App Street View en iOS y Android.</li>
          </ul>
        </section>

        <section>
          <h2>Opción 1 — App Street View (gratis)</h2>
          <ol>
            <li>Instala la app e inicia sesión con la cuenta de la ficha.</li>
            <li>Icono de cámara → captura guiada de una esfera 360°.</li>
            <li>Confirma el pin en la dirección y publica en Maps.</li>
            <li>Espera la revisión de Google (a menudo 24–72 h).</li>
          </ol>
        </section>

        <section>
          <h2>Opción 2 — Travvir (varias habitaciones)</h2>
          <p>
            Captura en el móvil, enlaza habitaciones, embed en tu web y publica
            en Google con Compartir → Google Street View. Travvir usa su
            <strong>cuenta editor en Street View</strong> — no tu cuenta Google
            personal. Detalles en la
            <a href="/blog/es/publicar-google-street-view">guía de publicación</a>.
          </p>
        </section>

        <section>
          <h2>Comparativa</h2>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>App Street View</th>
                <th>Travvir</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Varias habitaciones</td>
                <td>Escena a escena</td>
                <td>Tour enlazado</td>
              </tr>
              <tr>
                <td>Web + hotspots</td>
                <td>Limitado</td>
                <td>Sí</td>
              </tr>
              <tr>
                <td>Publicar en Maps</td>
                <td>Tu cuenta Google en la app Street View</td>
                <td>Desde Travvir (cuenta editor de Travvir)</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>Preguntas frecuentes</h2>
          <p>
            <strong>¿Cuánto tarda Google?</strong> Normalmente 24–72 horas tras
            enviar las imágenes.
          </p>
          <p>
            <strong>Con Travvir:</strong> no hace falta vincular tu cuenta
            Google — publicación con la cuenta editor de Travvir.
            <strong>Con la app Street View:</strong> inicia sesión con una cuenta
            que gestione el perfil de negocio de esa dirección.
          </p>
        </section>

        <section class="continue-reading">
          <h2>Seguir leyendo</h2>
          <ul>
            <li>
              <a href="/blog/es/publicar-google-street-view"
                >Publicar en Google Street View con Travvir</a
              >
            </li>
            <li>
              <a href="/blog/es/tour-virtual-google-mi-negocio"
                >Tour virtual en Google Business</a
              >
            </li>
          </ul>
        </section>

        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";
const postData = blogPostsData.find((p) => p.slug === "guia-google-maps-360");

useBlogSeo({
  title:
    "Google Maps 360 y app Street View: guía para negocios [2026] | Travvir",
  description:
    "Qué es Google Maps 360 en tu ficha, cómo usar la app Street View y cuándo publicar un tour 360° completo con Travvir.",
  keywords:
    "google maps 360, app street view, google street view, fotos 360 google negocio",
  slug: "guia-google-maps-360",
  image: postData?.image,
  postData,
  lang: "es",
});
</script>
